import { AnimatePresence, motion } from "motion/react";
import { ChevronDown, ChevronUp } from "lucide-react";
import type { ExamHubTeacher } from "../../../types/examHub";

export default function TeacherMini({
  teacher,
  onExpand,
  expanded,
}: {
  teacher: ExamHubTeacher;
  onExpand: () => void;
  expanded: boolean;
}) {
  return (
    <div>
      <button
        onClick={onExpand}
        className="w-full flex items-center gap-2.5 p-2.5 rounded-xl bg-slate-50 hover:bg-slate-100 transition-colors text-left cursor-pointer"
      >
        <img
          src={teacher.avatar}
          alt={teacher.name}
          className="w-8 h-8 rounded-lg object-cover flex-shrink-0"
          style={{ backgroundColor: teacher.avatarColor }}
        />
        <div className="flex-1 min-w-0">
          <p className="text-[12px] text-slate-800" style={{ fontWeight: 700 }}>
            {teacher.name}
          </p>
          <p className="text-[10px] text-slate-400" style={{ fontWeight: 400 }}>
            {teacher.experience}
          </p>
        </div>
        {expanded ? (
          <ChevronUp className="w-3.5 h-3.5 text-slate-400 flex-shrink-0" />
        ) : (
          <ChevronDown className="w-3.5 h-3.5 text-slate-400 flex-shrink-0" />
        )}
      </button>
      <AnimatePresence>
        {expanded && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="overflow-hidden"
          >
            <div className="px-3 pt-3 pb-1 flex flex-col gap-1.5">
              <p
                className="text-[11px] text-slate-500"
                style={{ fontWeight: 500 }}
              >
                {teacher.qualification}
              </p>
              <p
                className="whitespace-pre-line text-[11px] text-slate-500 leading-relaxed"
                style={{ fontWeight: 400 }}
              >
                {teacher.bio}
              </p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
